import Mechanics from './Mechanics';

export default Mechanics;
